/* unplugin-vue-components disabled */import { render } from "./HeaderNotifications.vue?vue&type=template&id=7dd34460&scoped=true"
import script from "./HeaderNotifications.vue?vue&type=script&lang=js"
export * from "./HeaderNotifications.vue?vue&type=script&lang=js"

import "./HeaderNotifications.vue?vue&type=style&index=0&id=7dd34460&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd34460"]])

export default __exports__